import { ReactComponent as FlagIcon } from "./svg/br-flag.svg";
import "../flag-icon.scss";

export const BRFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
